import React from 'react';

/**
 * Signals that a drawer's content is being rendered **inline** (docked as a
 * side panel, e.g. the Grand Livre / Balance inspection panel) rather than in
 * the modal overlay. When inline, the per-drawer `DrawerHeaderContent` title
 * bar is redundant with the panel's own header, so it hides itself and instead
 * publishes its title to the host panel via `setTitle`.
 */
export interface InlineDrawerContextValue {
  inline: boolean;
  setTitle?: (title: React.ReactNode) => void;
}

export const InlineDrawerContext =
  React.createContext<InlineDrawerContextValue>({ inline: false });

export const useInlineDrawer = () => React.useContext(InlineDrawerContext);
